// src/services/api.js

import axios from 'axios';


// Create an Axios instance with the baseURL from environment variables
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost',
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  })

  failedQueue = [];
}

api.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      return new Promise(function(resolve, reject) {
        failedQueue.push({ resolve, reject })
      }).then(token => {
        originalRequest.headers['Authorization'] = 'Bearer ' + token;
        return axios(originalRequest);
      }).catch(err => {
        return Promise.reject(err);
      })
    }

    originalRequest._retry = true;
    isRefreshing = true;

    const refresh = localStorage.getItem('refresh_token');
    return new Promise(function (resolve, reject) {
      axios.post('/api/auth/refresh/', { refresh })
        .then(({ data }) => {
          localStorage.setItem('access_token', data.access);
          api.defaults.headers.common['Authorization'] = 'Bearer ' + data.access;
          originalRequest.headers['Authorization'] = 'Bearer ' + data.access;
          processQueue(null, data.access);
          resolve(axios(originalRequest));
        })
        .catch((err) => {
          processQueue(err, null);
          reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        })
    });
  }

  return Promise.reject(error);
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API methods
export const credits = () => {
  return api.get('/api/osint/credit/');
};
export const authenticate = (username, password) => {
  return api.post('/api/auth/', { username, password });
};

export const getProfile = () => {
  return api.get('/api/user/');
};

export const fetchGeolocationEvents = () => {
  return api.get('/api/osint/event/', {
    params: { event_type: 'GEOLOCATION' },
  });
};

// Other API methods...
export const refreshToken = () => {
  const refresh = localStorage.getItem('refresh_token');
  return api.post('/api/auth/refresh/', { refresh })
    .then(({ data }) => {
      localStorage.setItem('access_token', data.access);
      api.defaults.headers.common['Authorization'] = 'Bearer ' + data.access;
      return data;
    });
};

export default api;